import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SmartLocalStorageService } from '../services/smart-local-storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AdminGuard implements CanActivate {
	constructor(private router: Router, private auth: AuthService, private smartLocalStorage: SmartLocalStorageService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.smartLocalStorage.localStorageUser.pipe(
			map((user) => {
				const isAdmin = this.auth.isAdmin();
				if (!isAdmin) {
					this.router.navigate(['/']);
				}
				return !!isAdmin;
			})
		);
	}
}
